var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<a uib-dropdown-toggle href=\"#\" class=\"dropdown-toggle\">\n{{ vm.language.selected.label | translate }} <span class=\"caret\"></span>\n</a>\n<ul uib-dropdown-menu class=\"dropdown-menu\" role=\"menu\">\n<li role=\"menuitem\" ng-repeat=\"lang in vm.availableLanguages\">\n<a ng-click=\"vm.setLanguage(lang)\" href=\"#\">{{lang.label | translate}}</a>\n</li>\n</ul>\n";
var id1="core/-i18n/language-picker/language_picker.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/-i18n/language-picker/language_picker.html
// module id = 914
// module chunks = 0